import { FC } from 'react';
import { TypographyProps } from '../types';
import { Size } from '../enums';
import { Caption } from '../../../typography/caption';
import { Subheadline } from '../../../typography/subheadline';

export const Entry: FC<TypographyProps> = ({ className, size, children }) => {
  if (size === Size.SMALL) {
    return (
      <Caption level={1} weight={2} className={className}>
        {children}
      </Caption>
    );
  }

  return (
    <Subheadline level={2} weight={2} className={className} caps>
      {children}
    </Subheadline>
  );
};
